<template>
  <div class="mt3">
    <div v-if="!labelEditing">
      Label:
      <span class="text-bold mr-2">{{
        project.label ? project.label : project.id
      }}</span>
      <el-button
        v-if="
          currentUser && project.userId === currentUser.uid
        "
        class="mr-2"
        icon="el-icon-edit"
        size="mini"
        @click="editLabelStart"
      ></el-button>
    </div>

    <div class="mt-3" v-if="labelEditing">
      <el-input
        :disabled="labelSaving"
        maxlength="30"
        class="mr-2"
        size="small"
        style="width: 200px;"
        v-model="label"
      ></el-input>
      <el-button
        :loading="labelSaving"
        type="primary"
        icon="el-icon-check"
        size="small"
        :disabled="!label"
        @click="editLabelSave"
      ></el-button>
      <el-button
        :disabled="labelSaving"
        class="mr-2"
        type="info"
        icon="el-icon-close"
        size="small"
        @click="editLabelCancel"
      ></el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProjectService from './project-service';
import * as Sentry from '@sentry/browser';

export default {
  name: 'app-project-label-edit',

  props: ['project'],

  data() {
    return {
      label: null,
      labelEditing: false,
      labelSaving: false,
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
  },

  methods: {
    editLabelStart() {
      this.label = this.project.label;
      this.labelEditing = true;
    },

    async editLabelCancel() {
      this.label = this.project.label;
      this.labelEditing = false;
    },

    async editLabelSave() {
      if (!this.label) {
        return;
      }

      try {
        this.labelSaving = true;
        await ProjectService.updateLabel(
          this.project.id,
          this.label,
        );
        this.project.label = this.label;
        this.labelSaving = false;
        this.labelEditing = false;
      } catch (error) {
        Sentry.captureException(error);
        this.label = this.project.label;
        this.labelSaving = false;
      }
    },
  },
};
</script>

<style></style>
